import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { IncidentTypes } from "../../api/incidents.service";
import { incidentsGuard } from "./incidents-auth.token";
import { HomeComponent } from "./home/home.component";
import { CreateIncidentComponent } from "./create-incident/create-incident.component";
import { CreateWitnessReportComponent } from "./create-witness-report/create-witness-report.component";
import { EditIncidentComponent } from "./edit-incident/edit-incident.component";
import { ViewIncidentComponent } from "./view-incident/view-incident.component";
import { ViewWitnessReportComponent } from "./view-witness-report/view-witness-report.component";
import { PickReportTypeComponent } from "./pick-report-type/pick-report-type.component";
import { SubmitExternalReportComponent } from "./external/submit-external-report/submit-external-report.component";

const routes: Routes = [

  {
    path: "",
    component: HomeComponent,
    title: "Incident Management",
    canActivate: [incidentsGuard]
  },
  {
    path: "pick-report-type",
    component: PickReportTypeComponent,
    title: "Create Incident Report",
  },
  {
    path: "create",
    component: CreateIncidentComponent,
    title: "Create Incident",
    canActivate: [incidentsGuard]
  },
  {
    path: "incident-reports/witness/create",
    component: CreateWitnessReportComponent,
    data: { incidentType: IncidentTypes.IncidentReportWitness },
    title: "Create Witness Report",
    canActivate: [incidentsGuard],
  },
  {
    path: "incident-reports/witness/:id",
    component: ViewWitnessReportComponent,
    data: { incidentType: IncidentTypes.IncidentReportWitness },
    title: "Witness Report Details",
    canActivate: [incidentsGuard],
  },
  {
    path: "incident-reports/staff-or-participant/create",
    component: CreateWitnessReportComponent,
    data: { incidentType: IncidentTypes.IncidentReportStaffOrParticipant },
    title: "Create Staff or Participant Report",
    canActivate: [incidentsGuard],
  },
  {
    path: "incident-reports/staff-or-participant/:id",
    component: ViewWitnessReportComponent,
    data: { incidentType: IncidentTypes.IncidentReportStaffOrParticipant },
    title: "Staff or Participant Report Details",
    canActivate: [incidentsGuard],
  },
  {
    path: "incident-reports/supervisor/create",
    component: CreateWitnessReportComponent,
    data: { incidentType: IncidentTypes.IncidentReportSupervisor },
    title: "Create Supervisor Report",
    canActivate: [incidentsGuard],
  },
  {
    path: "incident-reports/supervisor/:id",
    component: ViewWitnessReportComponent,
    data: { incidentType: IncidentTypes.IncidentReportSupervisor },
    title: "Supervisor Report Details",
    canActivate: [incidentsGuard],
  },
  {
    path: "incident-reports/missing-person/create",
    component: CreateWitnessReportComponent,
    data: { incidentType: IncidentTypes.IncidentReportMissingPerson },
    title: "Create Missing Person Report",
    canActivate: [incidentsGuard],
  },
  {
    path: "incident-reports/missing-person/:id",
    component: ViewWitnessReportComponent,
    data: { incidentType: IncidentTypes.IncidentReportMissingPerson },
    title: "Missing Person Report Details",
    canActivate: [incidentsGuard],
  },
  {
    path: "incident-reports/:id",
    component: ViewWitnessReportComponent,
    title: "Incident Report Details",
    canActivate: [incidentsGuard],
  },
  {
    path: ":id",
    component: ViewIncidentComponent,
    title: "Incident Details",
    canActivate: [incidentsGuard]
  },
  {
    path: ":id/edit",
    component: EditIncidentComponent,
    title: "Edit Incident",
    canActivate: [incidentsGuard],

  },
  {
    path: "external/submit-report/:id",
    component: SubmitExternalReportComponent
    //no auth guard here on purpose
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IncidentsRoutingModule { }
